import { useMemo } from "react"
import { groupDataByYear, PeriodExtractor } from "../../utils"
import type { GenericPeriod } from "@/types"

export function useGetDataGroupedByYear<T extends GenericPeriod>(
  data: T[],
  extractor?: PeriodExtractor<GenericPeriod>
) {
  return useMemo(() => groupDataByYear(data, extractor), [data, extractor])
}
